import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "../css/css_pages/clientManagement.css";
import Cookies from "js-cookie";
import config from "../../config";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa"; // Import icons for pagination

const ClientList = () => {
  const [token, setToken] = useState(null);
  const [clients, setClients] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [clientsPerPage] = useState(20); // Number of clients per page
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const authToken = Cookies.get("authToken");
    setToken(authToken);
  }, []);

  useEffect(() => {
    fetchClients();
  }, [token]);

  const fetchClients = async () => {
    const token = Cookies.get("authToken");
    if (!token) {
      console.error("No token available to fetch clients");
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(
        `${config.API_URL}/tso-online/get-all-clients`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();

      if (Array.isArray(data)) {
        setClients(data);
      } else {
        console.error("Unexpected API response format:", data);
      }
    } catch (error) {
      console.error("Error fetching clients:", error);
    } finally {
      setLoading(false);
    }
  };

  // Filter clients based on the search query
  const filteredClients = clients.filter((client) =>
    client.customer_name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  // Pagination logic
  const indexOfLastClient = currentPage * clientsPerPage;
  const indexOfFirstClient = indexOfLastClient - clientsPerPage;
  const currentClients = filteredClients.slice(
    indexOfFirstClient,
    indexOfLastClient
  );

  // Change page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Calculate the range of page numbers to display
  const getPageNumbers = () => {
    const totalPages = Math.ceil(filteredClients.length / clientsPerPage);
    const maxPagesToShow = 3;
    let startPage = Math.max(1, currentPage - Math.floor(maxPagesToShow / 2));
    let endPage = Math.min(totalPages, startPage + maxPagesToShow - 1);

    if (endPage - startPage + 1 < maxPagesToShow) {
      startPage = Math.max(1, endPage - maxPagesToShow + 1);
    }

    return Array.from(
      { length: endPage - startPage + 1 },
      (_, i) => startPage + i
    );
  };

  // Handle search input change
  const handleSearchChange = (e) => {
    const query = e.target.value;
    setSearchQuery(query);
    if (query.length >= 2) {
      setCurrentPage(1); // Reset to the first page when searching
    }
  };

  return (
    <div className="client-management-page">
      <div
        className="header-section"
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          marginBottom: "20px",
          position: "relative",
        }}
      >
        <h1 className="client-list-title">Client List</h1>
      </div>

      {/* Search Bar */}
        <input
          type="text"
          placeholder="Search by client name..."
          value={searchQuery}
          onChange={handleSearchChange}
          style={{
            padding: "10px",
            fontSize: "14px",
            border: "1px solid #ccc",
            borderRadius: "5px",
            width: "93%",
            maxWidth: "300px",
            marginBottom: "20px",
          }}
        />

        {loading ? (
          <p className="loading">Loading...</p>
        ) : (
          <>
            <div className="client-list">
          {currentClients.map((client) => (
            <div key={client.id} className="client-card">
              <div className="client-info">
            <span className="client-name">
              {client.id && (
                <Link
              to={`/client-profile/${client.id}`}
              className="client-name-link"
              style={{ textDecoration: "none" }}
                >
              {client.customer_name}
                </Link>
              )}
            </span>
            <p className="client-address">
              <b>Address : </b>
              {client.address}
            </p>
            <p className="client-phone">
              <b>Customer phone : </b> {client.phone}
            </p>
            <p className="client-tso">
              <b>Assigned TSO : </b> {client.tso_name} | emp no:{" "}
              {client.tso_emp_no}
            </p>
            <p className="client-tso-phone">
              <b>Assigned TSO phone : </b> {client.tso_phone_no}
            </p>
              </div>
            </div>
          ))}
            </div>

            {/* Pagination */}
          <div className="pagination-container">
            <button
              onClick={() => paginate(currentPage - 1)}
              disabled={currentPage === 1}
              className="pagination-button"
            >
              <FaChevronLeft />
            </button>
            <div className="pagination-scroll">
              {getPageNumbers().map((pageNumber) => (
                <button
                  key={pageNumber}
                  onClick={() => paginate(pageNumber)}
                  className={`pagination-button ${
                    currentPage === pageNumber ? "active" : ""
                  }`}
                >
                  {pageNumber}
                </button>
              ))}
            </div>
            <button
              onClick={() => paginate(currentPage + 1)}
              disabled={
                currentPage ===
                Math.ceil(filteredClients.length / clientsPerPage)
              }
              className="pagination-button"
            >
              <FaChevronRight />
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default ClientList;
